import React from "react"

import CompositionForm from "../components/CompositionForm/CompositionForm"

const CompositionNew = () => {
  return <CompositionForm />
}

export default CompositionNew
